import { render, staticRenderFns } from "./lastInvoices.vue?vue&type=template&id=1f107ca2&"
import script from "./lastInvoices.vue?vue&type=script&lang=js&"
export * from "./lastInvoices.vue?vue&type=script&lang=js&"
import style0 from "./lastInvoices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports